import * as React from "react";
import { connect } from "react-redux";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { Link } from "react-router-dom";

class CustomerServiceInfo extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.CustomerService.HealthPlan.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    getAddress(path) {
        return (
            <div className="details-icon-prepend cs-submit-help">
                <Link to={path}>
                    <div className="icon-col">
                        <span className="icon-messages" />
                    </div>
                    <div className="details-col">
                            Submit a Help Request
                    </div>
                </Link>
            </div>
        );
    }

    getPhoneNumber(phoneNumber, index) {
        return (
            <div className="details-icon-prepend" key={'phone' + index}>
                <a className="phone-link" href={"tel:" + phoneNumber.tel}>
                    <div className="icon-col">
                        <span className="icon-phone" />
                    </div>
                    <div className="details-col">
                        {phoneNumber.label}
                    </div>
                </a>
            </div>
        );
    }

    getPhone(phoneNumber, index) {
        if (index < 1) {
            return (<a key={'tty' + index} className="phone-link" href={"tel:" + phoneNumber}>{phoneNumber}</a>);
        }
        else {
            return (<React.Fragment key={'tty' + index}><span> or </span><a className="phone-link" href={"tel:" + phoneNumber}>{phoneNumber}</a></React.Fragment>);
        }
    }

    getTTY(phoneNumbers) {
        return (
            <div className="details-icon-prepend">
                <div className="details-key">
                    TTY:
                </div>
                <div className="details-col">
                    {/*phoneNumbers.map((phoneNumber, index) => console.log(index + " = " + phoneNumber + " = " + phoneNumbers[index]))*/}
                    {phoneNumbers.map((phoneNumber, index) => {
                        return this.getPhone(phoneNumber, index);
                    })
                    }
                </div>
            </div>
        );
    }

    getFax(phoneNumber, index) {
        return (
            <div key={'fax' + index} className="details-icon-prepend">
                <div className="details-key">
                    Fax:
                </div>
                <div className="details-col">
                    <span>{phoneNumber}</span>
                </div>
            </div>
        );
    }

    getSWHPMembers() {
        return {
            "Members": [
                {
                    "MemberType": "Individuals & Family Members",
                    "Description": "Information and support for Employer and marketplace insurance plans",
                    "SubmitLink": true,
                    "Phones": [{ label: "1-800-321-7947", tel: "1-800-321-7947"}],
                    "TTY": ["7-1-1"],
                    "Fax": ["1-254-298-3385"]
                },
                {
                    "MemberType": "Medicare Members",
                    "Description": "Information and support for Medicare plans, including SeniorCare Advantage",
                    "SubmitLink": true,
                    "Phones": [{ label: "1-866-334-3141", tel: "1-866-334-3141" }],
                    "TTY": ["7-1-1"]
                },
                {
                    "MemberType": "RightCare Members",
                    "Description": "Information and support for the STAR Medicaid Plan",
                    "Phones": [{ label: "1-855-TX-RIGHT", tel: "1-855-897-4448" }],
                    "TTY": ["1-800-855-2880"]
                },
                {
                    "MemberType": "Nurse Advice Line",
                    "Description": "Nurses are available 24 hours a day, 7 days a week.",
                    "Phones": [{ label: "1-877-505-7947", tel: "1-877-505-7947" }],
                }]
        };
    }

    getFirstCareMembers() {
        return {
            "Members": [
                {
                    "MemberType": "HMO (including TRS)",
                    "Phones": [{ label: "1-800-884-4901", tel: "1-800-884-4901" }]
                },
                {
                    "MemberType": "PPO",
                    "Phones": [{ label: "1-800-240-3270", tel: "1-800-240-3270" }]
                },
                {
                    "MemberType": "Marketplace",
                    "Phones": [{ label: "1-855-572-7238", tel: "1-855-572-7238" }]
                },
                {
                    "MemberType": "Administrative Services",
                    "Phones": [{ label: "1-888-249-7366", tel: "1-888-249-7366" }]
                },
                {
                    "MemberType": "Medicaid (STAR)",
                    "Phones": [{ label: "1-800-431-7798", tel: "1-800-431-7798" }]
                },
                {
                    "MemberType": "CHIP",
                    "Phones": [{ label: "1-877-639-2447", tel: "1-877-639-2447" }]
                },
                {
                    "MemberType": "FirstCare Advantage Dual SNP (HMO SNP)¹",
                    "Phones": [{ label: "1-866-229-4969", tel: "1-866-229-4969" }]
                },
                {
                    "MemberType": "TTY/TDD",
                    "Phones": [{ label: "7-1-1", tel: "7-1-1" }]
                }]
        };
    }

    getMedicalRecords() {
        const { technicalHelpDeskNumber, technicalHelpDeskHours, enableNewHealthPlan } = this.props;
        return (<div className="row">
            <div className="col-12">
                <h2 className={enableNewHealthPlan ? "subsection-heading" : "subsection-heading_NoHealthPlans"}>Appointments and Refills</h2>
                <p>Appointment scheduling will vary depending on the specialty, though timely appointments are available for urgent problems.</p>
                <p>Most of our specialties do not require your primary care physician's referral, but some do. Refer to the specialty's web page for more information.</p>
                <p>To expedite your renewal request, please contact your pharmacy first so that an electronic request is generated. Please allow us at least 3 business days to process your renewal request.</p>
                <h2 className="subsection-heading">Understanding Billing and Financial Assistance</h2>
                <p>Thank you for choosing Baylor Scott & White Health. Our mission is to serve the health needs of individuals, families and communities by delivering quality and compassionate care to all. Health insurance and hospital bills can be confusing. The guide should help you understand your bill and also explain how you may receive financial assistance if you are unable to pay. It is part of our commitment to provide financial advocacy for our patients.</p>
                <p>If you have questions about your bill, please call the phone number provided on your statement. Patient account representatives are available to answer your questions regarding bills or other account concerns Monday through Friday 8:00AM - 5:00PM at <a href={"tel:800.994.0371"} className="phone-link">800.994.0371</a>.</p>
                <h2 className="subsection-heading">Medical Records</h2>
                <p>Contact Release of Information for assistance in obtaining copies of your medical records at <a href={"tel:214.820.2135"} className="phone-link">214.820.2135</a>. Our office is open Monday through Friday 8:00AM - 5:00PM.</p>
                <h2 className="subsection-heading">MyBSWHealth Technical Support</h2>
                <p>Call the MyBSWHealth technical help desk {technicalHelpDeskHours} at <a href={"tel:" + technicalHelpDeskNumber} className="phone-link">{technicalHelpDeskNumber}</a>.</p>
            </div>
        </div>);
    }

    getHealthPlan() {
        const { hasSWHP, hasFirstCare, insuranceName } = this.props;
        const members = hasSWHP ? this.getSWHPMembers() : this.getFirstCareMembers();
        const healthPlan = insuranceName ? insuranceName : hasSWHP ? "Baylor Scott & White Health Plan" : "FirstCare Health Plans";
        const headingText = hasSWHP ? "Our goal is to connect you with high quality health care and provide responsive service." : "Call Monday through Friday, from 8 a.m. to 5 p.m. Central Time (CT) ¹.";
        const firstCareText = "¹ FirstCare Advantage Dual SNP (HMO SNP) Hours of Operation:  October 1 - March 31, 8 a.m. - 8 p.m. CT, daily; April 1 - September 30, 8 a.m. - 8 p.m. CT, Monday - Friday.";
        return (<div className="row">
            <div className="col-12">
                <div className="customerservice__top-section">
                    <h2>{healthPlan} Member Support</h2>
                    <p>{headingText}</p>
                </div>
                {hasSWHP
                    ? <React.Fragment>
                        {
                            members.Members.map((member, index) => {
                                return (<div className="customerservice__section" key={"cs-" + index}>
                                    <h3>{member.MemberType}</h3>
                                    {member.Description && <p>{member.Description}</p>}
                                    {member.SubmitLink && this.getAddress('/support')}
                                    {member.Phones && member.Phones.map((phoneNumber, index) => this.getPhoneNumber(phoneNumber, index))}
                                    {member.TTY && this.getTTY(member.TTY)}
                                    {member.Fax && member.Fax.map((phoneNumber, index) => this.getFax(phoneNumber, index))}
                                </div>);
                            })
                        }
                    </React.Fragment>
                    : <div className="row customerservice__phone-grid">
                        {
                            members.Members.map((member, index) => {
                                return (<div className="col-12 col-lg-6" key={"p-" + index}>
                                    <div className="row">
                                        <div className="col-12 col-sm-6 col-xl-7">
                                            <div className="phone-label">{member.MemberType}</div>
                                        </div>
                                        <div className="col-12 col-sm-6 col-xl-5">
                                            {member.Phones && member.Phones.map((phoneNumber) => this.getPhoneNumber(phoneNumber))}
                                        </div>
                                    </div>
                                    <div className="hr-divider" />
                                </div>);
                            })
                        }
                    </div>
                }
                
                {hasFirstCare && <div className="footer-text">{firstCareText}</div>}
            </div>
        </div>);
    }

    render() {
        const { hasSWHP, hasFirstCare, enableNewHealthPlan } = this.props;
        return enableNewHealthPlan && (hasSWHP || hasFirstCare) ? this.getHealthPlan() : this.getMedicalRecords();
    }
}

export default CustomerServiceInfo;